import React from "react";
import { LogOut } from "lucide-react";
import Logo from "../../components/Logo";

export default function DashboardHeader({ onSignOut }) {
  return (
    <header className="flex items-center justify-between px-6 py-4 border-b border-[#d6dcb6]">
      <div className="flex items-center gap-3">
        <Logo className="w-[260px]" />
        <span className="hidden md:inline-block font-display text-[#7d8e54] text-xl">| Admin</span>
      </div>
      <button
        onClick={onSignOut}
        className="flex items-center gap-2 text-sm text-[#7d8e54] hover:text-[#5b6a37]"
      >
        <LogOut className="w-4 h-4" /> Sign out
      </button>
    </header>
  );
}
